import { RecommendItem } from './recommend-item';

export { RecommendItem };
